import BaseListPresenter from "../../../../../base/BaseListPresenter";
import xhr from "../../../../../usecases/xhr/Xhr";

class SingleSearchLogsListPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    upsertUseCase,
    deleteObjectUseCase,
  ) {
    super(
      view,
      findObjectUseCase,
      countObjectUseCase,
      upsertUseCase,
      deleteObjectUseCase,
    );
    this.view = view;
    this.upsertUseCase = upsertUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
    this.all = false;
  }

  init() {
    this.limit = 20;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = ["searcher.affiliate", "searcher.branch"];
    this.keys = [];
    this.sort = { createdAt: -1 };
    this.current = 1; // 🔹 track page #
    this.progress = true;
    this.filterDate = null;

    this.reset();
  }

  async getObjects() {
    if (!this.filterDate || Object.keys(this.filterDate).length === 0) {
      this.objects = [];
      this.view.setObjects([]);
      this.view.setTotal(0);
      this.view.setCount(0);
      return;
    }
    this.showProgress();
    this.reset();
    await this.findObjects();
    this.hideProgress();
  }

  onChangeDate(where) {
    // SAVE DATE FILTER
    if (Object.keys(where).length > 0) {
      const [key] = Object.keys(where);
      const { $gte, $lte } = where[key];
      this.view.setDateFilter({ gte: $gte, lte: $lte });
    }

    this.filterDate = where;
    this.getObjects();
  }

  async countObjects() {
    try {
      const collection = this.view.getCollectionName();
      const query = this.createQuery();
      const objects = await this.findObjectUseCase.execute(collection, {
        where: query.where,
      });

      this.count = objects.length;
      // this.view.setCount(this.count);
    } catch (error) {
      this.view.showError(error);
    }
  }

  searchSubmit(search) {
    this.reset();
    this.search = search;
    this.getObjects();
  }

  createQuery({} = {}) {
    const { id } = this.view.getParams();
    const where = {
      searcher: { affiliate: { id: id } },

      // searcher: { affiliate: { code: id } },
    };

    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: {
        ...this.where,
        ...this.search,
        ...this.filter,
        ...this.filterDate,
        ...where,
      },
      include: this.include,
    };

    // if (!noLimit) {
    //   query.limit = this.limit; // 🟢 Apply limit only if not exporting
    //   query.skip = (this.current - 1) * this.limit;
    // }
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  // async findObjects() {
  //   const collection = this.view.getCollectionName();
  //   const query = this.createQuery();
  //   console.log("query", query);
  //   const session = localStorage.getItem("SESSION");

  //   this.objects = [];
  //   this.view.setObjects([]);
  //   this.view.setTotal(0);
  //   this.view.setCount(0);

  //   let buffer = [];
  //   const flushBuffer = () => {
  //     if (buffer.length === 0) return;
  //     this.objects = this.objects.concat(buffer);
  //     console.log("data", this.objects);
  //     // this.view.setObjects(this.objects);
  //     this.view.setTotal(this.objects.length);
  //     buffer = [];
  //   };
  //   const flushInterval = setInterval(flushBuffer, 1000);

  //   try {
  //     await xhr.get(`/${collection}`, {
  //       params: {
  //         where: query.where,
  //         include: query.include,
  //         sort: query.sort,
  //         keys: [
  //           "createdAt",
  //           "searched_alias",
  //           "searched_first_name",
  //           "searched_last_name",
  //           "searched_middle_name",
  //           "searcher.affiliate",
  //           "searcher.firstName",
  //           "searcher.middleName",
  //           "searcher.lastName",
  //           "searcher.branch",
  //         ],
  //       },
  //       headers: { "X-Session-Token": session },
  //       onChunk: (chunks) => {
  //         for (const obj of chunks) {
  //           console.log("push obj", obj);
  //           buffer.push(obj);
  //         }
  //         this.view.setCount(this.objects.length + buffer.length);
  //       },
  //     });
  //   } catch (error) {
  //     console.error("Error fetching objects:", error);
  //     this.view.showError(error);
  //   } finally {
  //     clearInterval(flushInterval);
  //     flushBuffer();
  //     this.view.setCount(this.objects.length);
  //     this.hideProgress();
  //     this.progress = false;
  //   }
  // }

  // async findObjects() {
  //   const collection = this.view.getCollectionName();
  //   const { where, sort } = this.createQuery();
  //   const session = localStorage.getItem("SESSION");
  //   const limit = 2000,
  //     skip = 0;
  //   const affiliateId = where.searcher.affiliate.id;

  //   const searcherIds = await xhr.aggregate(
  //     "users",
  //     [{ $match: { "affiliate.id": affiliateId } }, { $project: { _id: 1 } }],
  //     { headers: { "X-Session-Token": session } },
  //   );

  //   const searcherIdList = searcherIds.map((s) => s._id);
  //   console.log("searcherIdList", searcherIdList);

  //   const pipeline = [
  //     {
  //       $match: {
  //         $expr: {
  //           $and: [
  //             { $gte: ["$createdAt", { $toDate: where.createdAt.$gte }] },
  //             { $lte: ["$createdAt", { $toDate: where.createdAt.$lte }] },
  //           ],
  //         },
  //         "searcher.id": { $in: searcherIdList },
  //       },
  //     },
  //     { $sort: sort },
  //     {
  //       $facet: {
  //         data: [
  //           { $skip: skip },
  //           // { $limit: limit },
  //           {
  //             $lookup: {
  //               from: "users",
  //               localField: "searcher.id",
  //               foreignField: "_id",
  //               as: "searcherDoc",
  //             },
  //           },
  //           {
  //             $unwind: {
  //               path: "$searcherDoc",
  //               preserveNullAndEmptyArrays: true,
  //             },
  //           },
  //           {
  //             $lookup: {
  //               from: "affiliates",
  //               localField: "searcherDoc.affiliate.id",
  //               foreignField: "_id",
  //               as: "affiliateDoc",
  //             },
  //           },
  //           {
  //             $unwind: {
  //               path: "$affiliateDoc",
  //               preserveNullAndEmptyArrays: true,
  //             },
  //           },
  //           {
  //             $project: {
  //               createdAt: 1,
  //               searched_alias: 1,
  //               searched_first_name: 1,
  //               searched_last_name: 1,
  //               searched_middle_name: 1,
  //               "searcher.firstName": "$searcherDoc.firstName",
  //               "searcher.middleName": "$searcherDoc.middleName",
  //               "searcher.lastName": "$searcherDoc.lastName",
  //               "searcher.branch": "$searcherDoc.branch",
  //               "searcher.affiliate": "$affiliateDoc",
  //             },
  //           },
  //         ],
  //         totalCount: [{ $count: "count" }],
  //       },
  //     },
  //   ];

  //   try {
  //     const result = await xhr.aggregate(collection, pipeline, {
  //       headers: { "X-Session-Token": session },
  //     });

  //     this.view.setObjects(result[0]?.data || []);
  //     this.view.setTotal(result[0]?.totalCount?.[0]?.count || 0);
  //   } catch (error) {
  //     console.error("Error fetching objects:", error);
  //     this.view.showError(error);
  //   } finally {
  //     this.hideProgress();
  //     this.progress = false;
  //   }
  // }
  async findObjects() {
    const collection = this.view.getCollectionName();
    const { where, sort } = this.createQuery();
    const session = localStorage.getItem("SESSION");
    const affiliateId = where.searcher.affiliate.id;

    const searcherIds = await xhr.aggregate(
      "users",
      [{ $match: { "affiliate.id": affiliateId } }, { $project: { _id: 1 } }],
      { headers: { "X-Session-Token": session } },
    );

    const searcherIdList = searcherIds.map((s) => s._id);

    // Split into chunks small enough to stay well under the HTTP/2 header limit
    const CHUNK_SIZE = 50;
    const chunks = [];
    for (let i = 0; i < searcherIdList.length; i += CHUNK_SIZE) {
      chunks.push(searcherIdList.slice(i, i + CHUNK_SIZE));
    }

    const buildPipeline = (idChunk) => [
      {
        $match: {
          $expr: {
            $and: [
              { $gte: ["$createdAt", { $toDate: where.createdAt.$gte }] },
              { $lte: ["$createdAt", { $toDate: where.createdAt.$lte }] },
            ],
          },
          "searcher.id": { $in: idChunk },
          ...this.search,
        },
      },
      { $sort: sort },
      {
        $facet: {
          data: [
            {
              $lookup: {
                from: "users",
                localField: "searcher.id",
                foreignField: "_id",
                as: "searcherDoc",
              },
            },
            {
              $unwind: {
                path: "$searcherDoc",
                preserveNullAndEmptyArrays: true,
              },
            },
            {
              $lookup: {
                from: "affiliates",
                localField: "searcherDoc.affiliate.id",
                foreignField: "_id",
                as: "affiliateDoc",
              },
            },
            {
              $unwind: {
                path: "$affiliateDoc",
                preserveNullAndEmptyArrays: true,
              },
            },
            {
              $lookup: {
                from: "branches",
                localField: "searcherDoc.branch.id",
                foreignField: "_id",
                as: "branchDoc",
              },
            },
            {
              $unwind: {
                path: "$branchDoc",
                preserveNullAndEmptyArrays: true,
              },
            },
            {
              $project: {
                createdAt: 1,
                searched_alias: 1,
                searched_first_name: 1,
                searched_last_name: 1,
                searched_middle_name: 1,
                searched_company: 1,
                "searcher.firstName": "$searcherDoc.firstName",
                "searcher.middleName": "$searcherDoc.middleName",
                "searcher.lastName": "$searcherDoc.lastName",
                "searcher.branch": "$branchDoc",
                "searcher.affiliate": "$affiliateDoc",
              },
            },
          ],
          totalCount: [{ $count: "count" }],
        },
      },
    ];

    try {
      // Run all chunk queries in parallel
      const chunkResults = await Promise.all(
        chunks.map((idChunk) =>
          xhr.aggregate(collection, buildPipeline(idChunk), {
            headers: { "X-Session-Token": session },
          }),
        ),
      );

      // Merge results across all chunks
      const allData = chunkResults.flatMap((r) => r[0]?.data || []);
      const totalCount = chunkResults.reduce(
        (sum, r) => sum + (r[0]?.totalCount?.[0]?.count || 0),
        0,
      );

      // Re-sort the merged set (each chunk was only sorted within itself)
      allData.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

      this.view.setObjects(allData);
      this.view.setTotal(totalCount);
    } catch (error) {
      console.error("Error fetching objects:", error);
      this.view.showError(error);
    } finally {
      this.hideProgress();
      this.progress = false;
    }
  }
}

export default SingleSearchLogsListPresenter;
